import type { ClipboardEvent } from 'react';

export const ACCEPT = '.png,.jpg,.jpeg,.gif,.webp,.pdf,.docx,.xlsx,.csv,.txt,.log,.md,.json,.zip';
export function pastedFiles(event: ClipboardEvent): File[] {
  const files = Array.from(event.clipboardData?.files ?? []);
  if (files.length) event.preventDefault();
  return files;
}
export function addDraftFiles(current: File[], incoming: File[]): File[] {
  const next = [...current, ...incoming];
  if (next.length > 10 || next.reduce((sum, file) => sum + file.size, 0) > 50 * 1024 * 1024)
    throw Error('Choose up to 10 files totaling no more than 50 MB.');
  for (const file of incoming) {
    if (file.size === 0 || file.size > 20 * 1024 * 1024)
      throw Error(`${file.name}: Files must be nonempty and no larger than 20 MB.`);
    if (!ACCEPT.split(',').some((extension) => file.name.toLowerCase().endsWith(extension)))
      throw Error(`${file.name}: Choose an image, PDF, Office document, text, JSON, or ZIP file.`);
  }
  return next;
}
